import React from 'react';
import {
  BeforeYouScheduleStep,
  ScheduleAppointmentWizard,
} from '../scheduleAppointmentWizard';
import { PresenterState } from './PresenterState';
import { CernerAppointmentDetails } from '../../api/models';
import { AppointmentDetails } from '../appointmentDetails';
import { LoadingSpinner, LoadingSpinnerSize, StackedColumn } from '../../core';

interface ScheduleAppointmentPresenterProps {
  state: PresenterState;
  appointmentDetails: CernerAppointmentDetails;
  errorCode?: string;
  onContinueIntro: () => void;
  onSubmitAppointment: () => void;
  onWizardProgressed: () => void;
}

const ScheduleAppointmentPresenter: React.FC<
  ScheduleAppointmentPresenterProps
> = (props: ScheduleAppointmentPresenterProps) => {
  return (
    <>
      {props.state === PresenterState.Intro ? (
        <BeforeYouScheduleStep onContinue={props.onContinueIntro} />
      ) : props.state === PresenterState.ScheduleAppointment ? (
        <StackedColumn>
          <LoadingSpinner
            label="Scheduling appointment..."
            size={LoadingSpinnerSize.Medium}
          />
        </StackedColumn>
      ) : props.state === PresenterState.AppointmentScheduled ? (
        <AppointmentDetails appointmentDetails={props.appointmentDetails} />
      ) : (
        <ScheduleAppointmentWizard
          onSubmitAppointment={props.onSubmitAppointment}
          errorText={
            props.state === PresenterState.SchedulingError
              ? props.errorCode
              : undefined
          }
          onWizardProgressed={props.onWizardProgressed}
        />
      )}
    </>
  );
};

export default ScheduleAppointmentPresenter;
